import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
    width: 100%;
    height: 100%;
    background: ${props => props.theme.colors.c01} !important;
    background-color: ${props => props.theme.colors.c01} !important;
    font-size: 14px;
    color: ${props => props.theme.colors.c04};
    font-family: -apple-system, BlinkMacSystemFont, 'open sans', 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  }
  .disabled-box{
    filter: grayscale(80%) contrast(50%);
    pointer-events: none;
  }
  .label-pie text{
    background-color: red
  }
`;